class BasicModel {
  fromObject = (json) => {
    const propsList = Object.keys(this);
    propsList.map((propName) => {
      if (json[propName] !== undefined) this.[propName] = json[propName];
    });
  }

  onlyList = (fieldsList) => {
    const propsList = Object.keys(this);
    const result = {};
    fieldsList.map((field) => result[field] = this[field]);
    return result;
  }
}

export default BasicModel;
